import { createSlice } from "@reduxjs/toolkit";
import { fetchMyHomeworks } from "./myHomeworksThunk";

const myHomeworksSlice = createSlice({
  name: "homeworks",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyHomeworks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyHomeworks.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchMyHomeworks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default myHomeworksSlice.reducer;
